import { makeFifoCache } from '@sentry/utils';
export const PROFILE_QUEUE = makeFifoCache(20);
//# sourceMappingURL=cache.js.map